import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import DoDisturbOffIcon from '@mui/icons-material/DoDisturbOff';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import HomeIcon from '@mui/icons-material/Home';
import ImageIcon from '@mui/icons-material/Image';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SendIcon from "@mui/icons-material/Send";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IDroitsDesUtilisateurs, IUtilisateur, deleteUtilisateur, editUtilisateur, setDroitsDesUtilisateurs, updateDroitsDesUtilisateurs } from "./utilisateurAppGestionInterneSlice";
import Edit from "./Edit";
import PostEditDialog from "../../../SpiderWebSite/components/PostEditDialog";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../util/apiClient";
import { IReduxState } from "../../../store";
import { errorNotify, successNotify } from "../../../util/functions";
import ConfirmAction from "../../../components/Common/ConfirmAction";


export default function MenuApp(props: any) {
  //props
  const { user } = props;

  //redux
  const dispatch = useDispatch();
  const { droits } = useSelector((state: IReduxState) => state.droits)
  const { droitsDesUtilisateurs } = useSelector((state: IReduxState) => state.utilisateurAppGestionInterne)
  //hooks
  //Menu
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  //edit
  const [openEdition, setOpenEdition] = useState(false);
  const [editUserLoading, setEditUserLoading] = useState<boolean>(false)
  const [editUser, setEditUser] = useState<any>(null)
  const [arrayToEdit, setArrayToEdit] = useState<any>([])

  //suppression
  const [openSuppression, setOpenSuppression] = useState(false)
  const [suppressionLoading, setSuppressionLoading] = useState(false);

  //active ou desactive
  const [openActiveDesactive, setOpenActiveDesactive] = useState(false);
  const [loading, setLoading] = useState(false);



  //Ouvrir le menu
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  //Fermer le menu
  const handleClose = () => {
    setAnchorEl(null);
  };

  //Ouvrir la boite de dialog pour maj
  const handleEditionDialogOpen = (user: any) => {
    setOpenEdition(true);
    setEditUser(user)
    //obtenir les droits de l'utilisateur
    let newArray: any = []
    droitsDesUtilisateurs.filter(du => du.idPersonne === user.idPersonne).map(du => {
      droits.map(d => {
        if (du.idDroit === d.idDroit) {
          newArray.push(d.idDroit)
        }
      })
    })
    setArrayToEdit(newArray)
  };


  //Fermer la boite de dialog d'edition 
  const handleEditionDialogClose = () => {
    setOpenEdition(false);
  };

  const handleEdit = async (e: any) => {
    e.preventDefault()
    try {
      setEditUserLoading(true)
      const apiPayload = {
        user: editUser,
        rights: arrayToEdit
      }

      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/updateuserandhisrights", apiPayload)
      if (res.status === 1) {
        dispatch(editUtilisateur(editUser))
        dispatch(updateDroitsDesUtilisateurs(apiPayload))
        handleEditionDialogClose()
      } else {
        console.log("status !==1")
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:155 ~ handleSave ~ error:", error)
    } finally {
      setEditUserLoading(false)
    }
  }



  /////////////////////////////////////////////////  suppression  /////////////////////////////////////////////////////////
  //Ouvrir la boite de dialog suppression
  const handleSuppressionDialogOpen = () => {
    setOpenSuppression(true);
  };

  //Fermer la boite de dialog suppression
  const handleSuppressionDialogClose = () => {
    setOpenSuppression(false);
  };

  //Supprimer une application
  const handleDelete = async (e: any) => {
    e.preventDefault();
    try {
      setSuppressionLoading(true);
      const apiPayload = {
        idPersonne: user.idPersonne
      };

      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/deleteuserandhisrights",
        apiPayload
      );
      if (res.status === 1) {
        dispatch(deleteUtilisateur(user.idPersonne));
        dispatch(setDroitsDesUtilisateurs(res.data));
        setSuppressionLoading(false);
        handleSuppressionDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setSuppressionLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:147 ~ handleDelete ~ error:", error)
      setSuppressionLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };


  /////////////////////////////////////////////////// Active ou Desactive /////////////////////////////////////////////////////////
  //Ouvrir la boite de confirmation ActiveDesactive
  const handleActiveDesactiveDialogOpen = () => {
    setOpenActiveDesactive(true);
  };

  //Fermer la boite de confirmation ActiveDesactive
  const handleActiveDesactiveDialogClose = () => {
    setOpenActiveDesactive(false);
  };

  //Activer ou désactiver l'affichage de l'image à la bannière
  const handleSave = async (e: any) => {
    e.preventDefault();
    try {
      setLoading(true);
      //Constitution du payload
      const apiPayload = {
        idPersonne: user.idPersonne,
        status: user.status === 1 ? 0 : 1
      };
      //Envoie de la requete
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/handleactivedesactiveuser",
        apiPayload
      );
      if (res.status === 1) {
        dispatch(updateDroitsDesUtilisateurs(res.data));
        setLoading(false);
        handleActiveDesactiveDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:194 ~ handleSave ~ error:", error)
      setLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };



  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Options">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            handleActiveDesactiveDialogOpen();
          }}
        >
          <ListItemIcon>
            {user.status === 0
              ? <DoDisturbOffIcon fontSize="small" color="error" />
              : <DoDisturbOnIcon fontSize="small" />

            }
          </ListItemIcon>
          {user.status === 0
            ? "Débloquer"
            : "Bloquer"
          }
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleEditionDialogOpen(user);
          }}
        >
          <ListItemIcon>
            <CreateIcon fontSize="small" />
          </ListItemIcon>
          Modifier
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleSuppressionDialogOpen();
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          Supprimer
        </MenuItem>
      </Menu>

      {/* editer */}
      <PostEditDialog
        onClose={handleEditionDialogClose}
        open={openEdition}
        dialogContent={
          <Edit
            editUser={editUser}
            setEditUser={setEditUser}
            arrayToEdit={arrayToEdit}
            setArrayToEdit={setArrayToEdit}
          />}
        actionFunc={handleEdit}
        title="Edition"
        editLoading={editUserLoading}
      />

      {/* Supprimer l'user */}
      <ConfirmAction
        title={`Suppression`}
        dialogContent={`Voulez vous réellement supprimer cet utilisateur ?`}
        actionLabel="Oui"
        open={openSuppression}
        handleClose={handleSuppressionDialogClose}
        actionFunction={handleDelete}
        addLoading={suppressionLoading}
        iconeSauveButton={<DeleteIcon />}
      />

      {/* Activer ou désactiver */}
      <ConfirmAction
        title={`${user.status === 0 ? "Désactiver" : "Activer"} cet utilisateur?`}
        dialogContent={`Voulez vous réellement effectuer cette opération?`}
        actionLabel="Valider"
        open={openActiveDesactive}
        handleClose={handleActiveDesactiveDialogClose}
        actionFunction={handleSave}
        addLoading={loading}
        iconeSauveButton={<SendIcon />}
      />

    </React.Fragment>
  );
}
